module["exports"] = [
  "სოფელი",
  "ძირი",
  "სკარი",
  "დაბა"
];
